import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PanelTemplate from '../../common/PanelTemplate';
import I18n from '../../../config/locales';
import Table from './table';
import Search from './search';
import Icons from '../Icons';
import SystemHeaderFooter from '../SystemHeaderFooter';
import SelectType from './selectType';
import settings from '../../../utils/settings';
import { isEmpty, get } from '../../../utils/lodash';
import { Divider, Box, CircularProgress } from '@material-ui/core';

const styles = theme => ({
  root: {
    width: '60%',
    minWidth: '60%',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      width: props => (props.windowWidth ? props.windowWidth - 74 : '100%')
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
      width: props => (props.windowWidth ? props.windowWidth - 58 : '100%')
    }
  },
  panelTemplate: {
    overflow: 'auto'
  },
  divider: {
    marginTop: theme.spacing(1)
  },
  systemHeader: {
    display: 'flex'
  },
  styleSystemTableLoader: {
    marginLeft: '45%'
  }
});
class index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: 'All',
      objectsList: [],
      selectedFilter: {
        Alerts: { name: 'All' },
        Activations: { name: 'All' }
      },
      filterOptions: []
    };
    this.alertListTotalCount = this.props.alertList.total_count === null ? 0 : this.props.alertList.total_count;
    this.activationListTotalCount =
      this.props.activationList.total_count === null ? 0 : this.props.activationList.total_count;
    this.leadListTotalCount = this.props.leadList.totalLeads === null ? 0 : this.props.leadList.totalLeads;
    this.selectOptions = [
      { All: 0 },
      ...(!this.props.fromITK
        ? [ { Alerts: this.alertListTotalCount }, { Activations: this.activationListTotalCount } ]
        : []),
      ...(this.props.leadOptIn ? [ { Leads: this.leadListTotalCount } ] : [])
    ];
    this.systemSearch = get(this.props.systemSavedSearch, 'system_groups', []) || [];
    this.siteSavedSearch = get(this.props.systemSavedSearch, 'site_saved_searches', []) || [];
    this.activationSavedSearch = get(this.props.systemSavedSearch, 'activation_saved_searches', []) || [];
    this.savedSearch = this.siteSavedSearch.map(search => {
      search.isSavedSearch = true;
      return search;
    });
    this.activationSearch = this.activationSavedSearch.map(search => {
      search.isSavedSearch = true;
      return search;
    });
  }

  componentDidMount = () => {
    this.setState({ objectsList: this.props.systemList.result });
    this.setFilterOptions();
  };

  handleUpdate = () => {
    const menuType = this.state.menu;
    if (menuType === 'All') this.setState({ objectsList: this.props.systemList.result });
    else if (menuType === 'Alerts') this.setState({ objectsList: this.props.alertList.result });
    else if (menuType === 'Activations') this.setState({ objectsList: this.props.activationList.result });
    else if (menuType === 'Leads') this.setState({ objectsList: this.props.leadList.result });
  };

  handleMenuChange = e => {
    this.setState({ menu: e.target.value }, () => {
      this.handleUpdate();
      this.setFilterOptions();
    });
  };

  getViewAllUrl = () => {
    if (this.state.menu === 'Activations') {
      return settings.enlightenMenuUrl('activations');
    } else if (this.state.menu === 'Leads') {
      return `dashboard/${this.props.companyId}/leads`;
    } else if (this.state.menu === 'Alerts') {
      return this.getViewAllAlertURL();
    }
  };

  getViewAllText = () => {
    if (this.state.menu === 'Leads') return I18n.t('dashboard.viewLeads');
  };

  handleShowActiveLeads = (activeLeads, cb) => {
    const criteria = activeLeads ? 'all' : 'active';
    this.props.getLeads({
      companyId: this.props.companyId,
      pageNum: 0,
      recordCount: 25,
      criteria: criteria,
      successCb: () => {
        this.handleUpdate();
        cb();
      }
    });
  };

  getViewAllAlertURL = () => {
    if (this.state.selectedFilter['Alerts'].name !== 'all') {
      const isSavedSearch = get(this.state.selectedFilter, 'Alerts.isSavedSearch', false) || false;
      const id = get(this.state.selectedFilter, 'Alerts.id');
      const searchParam = isSavedSearch ? `savedSearch=${id}` : `group_id=${id}`;
      return `${settings.enlightenMenuUrl('systems')}?${searchParam}&status=any`;
    }
    return '';
  };

  handleFilterChange = e => {
    let filterValue = this.state.filterOptions[e.target.value] || 'All';
    let searchParam = '';
    let searchParamList = [];
    const field = this.state.menu;

    if (filterValue === 'All') {
      filterValue = { name: 'All' };
      searchParam = `search_value=_ALL_SITES_`;
    } else if (get(filterValue, 'isSavedSearch', false)) {
      const filter = get(filterValue, 'filter', '') || '';
      const sort = get(filterValue, 'sort', '') || '';
      if (!isEmpty(filter)) {
        Object.keys(filter).forEach(key => key && searchParamList.push(`site[${key}][text]=${filter[key]}`));
      }
      if (!isEmpty(sort)) {
        Object.keys(sort).forEach(key => key && searchParamList.push(`site[${key}][order_by]=${sort[key]}`));
      }
      searchParam = searchParamList.join('&');
    } else {
      searchParam = `site[group_id][text]=${get(filterValue, 'id', '')}`;
    }
    const connector = searchParam ? '&' : '';
    this.setState({ selectedFilter: { ...this.state.selectedFilter, [field]: filterValue } });
    this.props.getFilteredList({
      searchParam: `${searchParam}${connector}limit=10`,
      searchType: field.substr(0, field.length - 1).toLowerCase(),
      successCbk: () => this.handleUpdate()
    });
  };

  handleFilterReset = () => {
    const field = this.state.menu;
    this.setState({ selectedFilter: { ...this.state.selectedFilter, [field]: { name: 'All' } } });
    this.props.getFilteredList({
      searchParam: `search_value=_ALL_SITES_&limit=10`,
      searchType: field.toLowerCase(),
      successCbk: () => this.handleUpdate()
    });
  };

  setFilterOptions = () => {
    let filterOptions = [];
    const field = this.state.menu;
    if (field === 'Alerts') {
      !isEmpty(this.savedSearch) && filterOptions.push(...this.savedSearch);
      !isEmpty(this.systemSearch) && filterOptions.push(...this.systemSearch);
    } else if (field === 'Activations') {
      !isEmpty(this.activationSearch) && filterOptions.push(...this.activationSearch);
    }
    this.setState({ filterOptions: { ...filterOptions } });
  };

  showLoader = () => {
    const { systemLoadingProps } = this.props;
    const { systemLoading, activationLoading, alertLoading } = systemLoadingProps;
    const { menu } = this.state;
    return (
      (menu === 'All' && systemLoading) ||
      (menu === 'Alerts' && alertLoading) ||
      (menu === 'Activations' && activationLoading)
    );
  };

  render() {
    const { searchList, companyId, getSearchResult, getLeads, currentlySending, classes } = this.props;
    const showAddNew = this.state.menu !== 'Alerts';
    return (
      <div className={classes.root}>
        <PanelTemplate
          header={I18n.t('dashboard.systems')}
          className={classes.panelTemplate}
          headerClassName={classes.headerTemplate}
          boxShadow
        >
          <Box className={classes.systemHeader}>
            <SelectType
              selectValue={this.state.menu}
              onSelectValueChange={this.handleMenuChange}
              selectOptions={this.selectOptions}
            />
            {showAddNew ? <SystemHeaderFooter isLead={this.state.menu === 'Leads'} /> : null}
          </Box>
          <Search
            searchList={searchList}
            getSearchResult={getSearchResult}
            field={this.state.menu}
            companyId={companyId}
            getLeads={getLeads}
            handleChange={this.handleShowActiveLeads}
            savedSearch={this.savedSearch}
            systemSearch={this.systemSearch}
            activationSavedSearch={this.activationSavedSearch}
            handleFilterChange={this.handleFilterChange}
            handleFilterReset={this.handleFilterReset}
            selectedFilter={this.state.selectedFilter}
          />
          {this.showLoader() ? (
            <CircularProgress className={classes.styleSystemTableLoader} />
          ) : (
            <Table
              objectsList={this.state.objectsList}
              headingColumn="name"
              subHeadingColumn="status_text"
              subHeadingColumnIcons={Icons}
              displayColumns={[ 'city', this.state.menu === 'Leads' ? 'lead_source' : 'state' ]}
              columnNames={[
                I18n.t('dashboard.city'),
                this.state.menu === 'Leads' ? I18n.t('dashboard.leadSource') : I18n.t('dashboard.state')
              ]}
              keyValue="system_table"
              menuType={this.state.menu}
              companyId={companyId}
              currentlySending={currentlySending}
            />
          )}

          <Divider className={classes.divider} />
          <SystemHeaderFooter footer viewAllUrl={this.getViewAllUrl()} viewAllText={this.getViewAllText()} />
        </PanelTemplate>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({
  currentlySending: state.leadReducer.currentlySending
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(index));
